<script lang="ts">
	import { page } from '$app/stores';
	import { translations } from '$lib/i18n/translations';
	import type { Property } from '$lib/satellite.types';
	import { onMount } from 'svelte';

	export let code: string;
	export let zone: string;

	let content: HTMLDivElement;

	// This is to force tailwind to preload classes
	// h-[600px]
	// h-[250px]
	// h-[620px]
	// h-[270px]

	const property = $page.data.property as Property;
	const t = translations(property.language);

	onMount(() => {
		if (code == '' || zone == '') {
			return;
		}

		content.innerHTML = `<div class="adplugg-tag" data-adplugg-access-code="${code}" data-adplugg-zone="${zone}"></div>`;

		const script = document.createElement('script');
		script.src = '//www.adplugg.com/serve/js/ad.js';
		script.async = true;

		content.appendChild(script);

		(window.AdPlugg = window.AdPlugg || []).push({ command: 'run' });
	});
</script>

<div class="max-w-[300px] mx-auto">
	<div bind:this={content} />
	<div class="text-xs text-right mt-1 text-gray-400">{t('ad')}</div>
</div>
